import React, { useState } from "react";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import { URL } from "../../../Services/Constant";
import { post } from "../../../Services/ApiHandler";
import toast from "react-hot-toast";

const SpecialSlots = ({
  superAdmin,
  setShowPopup,
  dates,
  setDates,
  selectedDate,
  setSelectedDate,
  handleDateSubmit,
  option,
  getDateList,
}) => {
  const [selectedDay, setSelectedDay] = useState(["06-02-2018"]);
  const [realDay, setRealDay] = useState("06-02-2018");
  const [showSchedule, setShowSchedule] = useState(false);
  const [schedule, setSchedule] = useState([]);
  const [index_, setIndex_] = useState(0);

  const user_details = JSON.parse(localStorage.getItem("user_details"));

  const handleDayClick = (day, ind) => {
    setSelectedDate(day);
    setRealDay(day);
    setIndex_(ind);
    setSchedule([]);
    setShowSchedule(false);
  };

  const handleDateRemove = async (item) => {
    let payload = {
      for_date: item?.date,
      knf_company_site_id: user_details?.knf_company_site_id,
    };
    console.log("SpecialDeletePayload", payload);
    const res = await post(URL.SPECIAL_DATE_DELETE, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      getDateList(user_details?.knf_company_site_id, index_);
    }
  };

  const handleToggle = (ind, type, value) => {
    let temp = [...dates];
    if (type == "toggle") {
      temp[ind] = {
        ...temp[ind],
        [type]: value,
        start_time: "",
        end_time: "",
      };
      setDates(temp);
      if (!value) {
        handleDateRemove(temp[ind]);
      }
    } else {
      temp[ind] = {
        ...temp[ind],
        [type]: value,
      };
      setDates(temp);
    }
  };

  //   console.log("schedule", schedule);

  const handleSubmit = () => {
    const updatedArray = [...schedule, realDay];
    setSelectedDay(updatedArray);
  };

  return (
    <div className="">
      <div className="slot-container ">
        <div className="days-scroll">
          {dates?.map((day, ind) => {
            return (
              <button
                key={ind}
                className={`f2 fs-sm-10 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 day-btn ${
                  selectedDate == day?.id ? "active" : ""
                }`}
                onClick={() => handleDayClick(day?.id, ind)}
              >
                {day?.for_date}
              </button>
            );
          })}
        </div>

        {!superAdmin && (
          <div className="d-flex ac-je my-3">
            <button className="import-btn" onClick={() => setShowPopup(true)}>
              import
            </button>
          </div>
        )}

        {dates?.length > 0 && (
          <div className="Oversall-box-special  flex-column ac-ja w-50">
            <div className="d-flex ae-js gap-3 my-4">
              <h3 className="f3 fs-sm-19 fs-md-21 fs-lg-23 fs-xl-25 fs-xxl-27">
                {dates?.[index_]?.for_date} Schedule
              </h3>
              <div
                className="gap-3 d-flex toggle-btn"
                onClick={() =>
                  handleToggle(
                    index_,
                    "toggle",
                    dates?.[index_]?.toggle ? false : true,
                  )
                }
                style={{ width: 89, height: 50, overflow: "hidden" }}
              >
                {dates?.[index_]?.toggle ? (
                  <ToggleOnIcon sx={{ fontSize: 60, color: "green" }} />
                ) : (
                  <ToggleOffIcon sx={{ fontSize: 60, color: "gray" }} />
                )}
              </div>
            </div>

            {dates?.[index_]?.toggle && (
              <div className="schedule-box ">
                <div className="time-inputs">
                  <div>
                    <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                      Start Time (mins)
                      <br />
                      Working Hrs
                    </label>
                    <input
                      type="time"
                      value={dates?.[index_]?.start_time}
                      onChange={(e) => {
                        handleToggle(index_, "start_time", e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <label className="f2 fs-sm-7 fs-md-9 fs-lg-11 fs-xl-13 fs-xxl-15">
                      End Time (mins)
                      <br />
                      Working Hrs
                    </label>
                    <input
                      type="time"
                      value={dates?.[index_]?.end_time}
                      onChange={(e) => {
                        handleToggle(index_, "end_time", e.target.value);
                      }}
                    />
                  </div>

                  {!superAdmin && (
                    <div className="mt-5 ms-5">
                      <button
                        className="submit-btn "
                        onClick={() => handleDateSubmit(index_)}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SpecialSlots;
